import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';

interface Props {
  open: boolean;
  loading: boolean;

  handleClose(): void;

  handleSynchronizeLinkedinAccount(): void;
}

const OnboardingIncompleteDialog: React.FC<Props> = ({ open, loading, handleClose, handleSynchronizeLinkedinAccount }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('onboardingIncomplete')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>
            <strong>{t('syncErrorLinkedinOnboardingIncompleteText1')}</strong>
          </Typography>
          <Typography className={classes.text}>
            <Trans i18nKey={'syncErrorLinkedinOnboardingIncompleteText2'}>
              Please go through the
              <a className={classes.link} href={'https://www.linkedin.com/sales/on-boarding/welcome'} target={'_blank'} rel={'noreferrer'}>
                welcome pages of the LinkedIn Sales Navigator
              </a>
              completely.
            </Trans>
          </Typography>
          <Typography className={classes.text}>{t('syncErrorLinkedinOnboardingIncompleteText3')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('retrySynchronization')} size={'small'} border={'rounded'} action={handleSynchronizeLinkedinAccount} disabled={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
    '&.highlight': {
      color: theme.palette.primary.main,
    },
  },
  link: {
    display: 'inline',
    fontSize: theme.typography.pxToRem(15),
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
    textAlign: 'left',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default OnboardingIncompleteDialog;
